<template>

	<main id="talent">

		<section class="talents-hero">

            <div class="talents-hero__container limit-width">

                <div class="talents-hero__content">

                    <h1>
                        {{ 'talent_page_landing' | staticTitle }}
                    </h1>

                    <h2>
                        {{ 'talent_page_landing' | staticContentAlt }}
                    </h2>

                    <vue-marked>
                        {{ 'talent_page_landing' | staticContent }}
                    </vue-marked>

                    <a href="#" class="btn">
                        {{ 'talent_page_landing_cta' | staticTitle }}
                    </a>

                </div>

                <div class="talents-hero__image">

                    <img
                        :src="'talent_page_landing' | staticImg"
                        alt="Reyrock Talent"
                    >

                </div>

            </div>

        </section>

        <section class="talent-person-platform">

            <div class="limit-width">

                <h2>
                    {{ 'talent_page_person_platform' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_person_platform' | staticContent }}
                </vue-marked>

                <span>
                    {{ 'talent_page_people_first' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_people_first' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_people_first' | staticContent }}
                </vue-marked>


            </div>

        </section>


		<section class="partners">

            <div class="partners__overlay"></div>

            <div class="partners__container limit-width">

                <div class="partners__left">

                    <span>
                        {{ 'talent_page_partners' | staticContentAlt }}
                    </span>

                    <h2>
                        {{ 'talent_page_partners' | staticTitle }}
                    </h2>

                </div>

                <div class="partners__right">

                    <ul>

                        <li
                            v-for="item in [
                                'talent_page_partners_item_1',
                                'talent_page_partners_item_2',
                                'talent_page_partners_item_3',
                                'talent_page_partners_item_4',
                                'talent_page_partners_item_5'
                            ]"
                            :key="item"
                        >

                            <strong>
                                {{ item | staticTitle }}
                            </strong>

                            <vue-marked>
                                {{ item | staticContent }}
                            </vue-marked>

                        </li>

                    </ul>

                    <vue-marked>
                        {{ 'talent_page_partners_statement' | staticContent }}
                    </vue-marked>

                </div>

            </div>

        </section>

        <section class="projects">

            <div class="projects__container limit-width">

                <span class="projects__label">
                    {{ 'talent_page_projects' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_projects' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_projects' | staticContent }}
                </vue-marked>


                <vue-marked>
                    {{ 'talent_page_projects_statement' | staticContent }}
                </vue-marked>

            </div>

        </section>

		
        <section class="talent-enduring-value">

            <div class="limit-width">

                <h2>
                    {{ 'talent_page_enduring_value' | staticTitle }}
                </h2>

                <h3>
                    {{ 'talent_page_enduring_value' | staticContentAlt }}
                </h3>

                <div>

                    <article
                        v-for="item in [
                            'talent_page_enduring_value_item_1',
                            'talent_page_enduring_value_item_2',
                            'talent_page_enduring_value_item_3',
                            'talent_page_enduring_value_item_4',
                            'talent_page_enduring_value_item_5'
                        ]"
                        :key="item"
                    >

                        <h3>
                            {{ item | staticTitle }}
                        </h3>

                        <vue-marked>
                            {{ item | staticContent }}
                        </vue-marked>

                    </article>

                </div>

                <div class="talent-enduring-value__statement">
                    <vue-marked>
                        {{ 'talent_page_enduring_value_statement' | staticContent }}
                    </vue-marked>
                </div>

            </div>

        </section>

        <section class="talent-ownership">

            <div class="limit-width">

                <div class="talent-ownership__intro">

                    <span>
                        {{ 'talent_page_ownership' | staticContentAlt }}
                    </span>

                    <h2>
                        {{ 'talent_page_ownership' | staticTitle }}
                    </h2>

                    <vue-marked>
                        {{ 'talent_page_ownership' | staticContent }}
                    </vue-marked>

                </div>

                <div class="talent-ownership__options">

                    <article
                        v-for="item in [
                            'talent_page_ownership_item_1',
                            'talent_page_ownership_item_2',
                            'talent_page_ownership_item_3',
                            'talent_page_ownership_item_4',
                            'talent_page_ownership_item_5',
                            'talent_page_ownership_item_6',
                            'talent_page_ownership_item_7'
                        ]"
                        :key="item"
                    >

                        <h3>
                            {{ item | staticTitle }}
                        </h3>

                    </article>

                </div>

                <div class="talent-ownership__statement">
                    <vue-marked>
                        {{ 'talent_page_ownership_statement' | staticContent }}
                    </vue-marked>
                </div>

            </div>

        </section>

        <section class="talent-ecosystem">

            <div class="limit-width">

                <span>
                    {{ 'talent_page_ecosystem' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_ecosystem' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_ecosystem' | staticContent }}
                </vue-marked>

                <div>

                    <article
                        v-for="item in [
                            'talent_page_ecosystem_item_1',
                            'talent_page_ecosystem_item_2',
                            'talent_page_ecosystem_item_3',
                            'talent_page_ecosystem_item_4',
                            'talent_page_ecosystem_item_5',
                            'talent_page_ecosystem_item_6',
                            'talent_page_ecosystem_item_7',
                            'talent_page_ecosystem_item_8',
                            'talent_page_ecosystem_item_9'
                        ]"
                        :key="item"
                    >

                        <h3>
                            {{ item | staticTitle }}
                        </h3>

                    </article>

                </div>

                <vue-marked>
                    {{ 'talent_page_ecosystem_statement' | staticContent }}
                </vue-marked>

            </div>

        </section>

        <section class="talent-bridgerocks">

            <div class="limit-width">

                <span>
                    {{ 'talent_page_bridgerocks' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_bridgerocks' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_bridgerocks' | staticContent }}
                </vue-marked>

                <div>

                    <article
                        v-for="item in [
                            'talent_page_bridgerocks_item_1',
                            'talent_page_bridgerocks_item_2',
                            'talent_page_bridgerocks_item_3',
                            'talent_page_bridgerocks_item_4'
                        ]"
                        :key="item"
                    >

                        <h3>
                            {{ item | staticTitle }}
                        </h3>

                        <vue-marked>
                            {{ item | staticContent }}
                        </vue-marked>

                    </article>

                </div>

                <vue-marked>
                    {{ 'talent_page_bridgerocks_statement' | staticContent }}
                </vue-marked>

            </div>

        </section>

        <section class="talent-beyond-career">

            <div class="limit-width">

                <h2>
                    {{ 'talent_page_beyond_career' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_beyond_career' | staticContent }}
                </vue-marked>

                <vue-marked>
                    {{ 'talent_page_beyond_career_statement' | staticContent }}
                </vue-marked>

            </div>

        </section>

        <section class="talent-selection">

            <div class="limit-width">

                <span>
                    {{ 'talent_page_selection' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_selection' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_selection' | staticContent }}
                </vue-marked>

                <div>

                    <article
                        v-for="item in [
                            'talent_page_selection_item_1',
                            'talent_page_selection_item_2',
                            'talent_page_selection_item_3',
                            'talent_page_selection_item_4',
                            'talent_page_selection_item_5',
                            'talent_page_selection_item_6'
                        ]"
                        :key="item"
                    >

                        <h3>
                            {{ item | staticTitle }}
                        </h3>

                        <vue-marked>
                            {{ item | staticContent }}
                        </vue-marked>

                    </article>

                </div>

                <vue-marked>
                    {{ 'talent_page_selection_statement' | staticContent }}
                </vue-marked>

            </div>

        </section>

        <section class="talent-not-agency">

            <div class="limit-width">

                <span>
                    {{ 'talent_page_not_agency' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'talent_page_not_agency' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'talent_page_not_agency' | staticContent }}
                </vue-marked>

            </div>

        </section>

        <section class="talent-final-cta">

            <div class="limit-width">

                <div class="talent-final-cta__main">

                    <h2>
                        {{ 'talent_page_final_cta' | staticTitle }}
                    </h2>

                    <div class="talent-final-cta__actions">

                        <a href="#" class="btn-primary">
                            {{ 'talent_page_final_cta_primary' | staticTitle }}
                        </a>

                        <a href="#" class="project__link">
                            {{ 'talent_page_final_cta_secondary' | staticTitle }}
                        </a>

                    </div>

                </div>

                <div class="talent-final-cta__copy">

                    <vue-marked>
                        {{ 'talent_page_final_cta' | staticContent }}
                    </vue-marked>

                </div>

            </div>

        </section>
	</main>

</template>


<script>
export default {

	name: 'Talent',

	methods: {

		loadUp() {

			document.title =
				'Bridgerocks | ' +
				this.$options.filters.i(this.$route.meta.title);

			if (window.mainUI && typeof window.mainUI === 'function')
				setTimeout(window.mainUI, 150);

		}

	},

	mounted() {

		this.loadUp();

	}

};
</script>

<style lang="scss">
#talent {

	.vue-markd-container {
		margin-bottom: 3rem !important;

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin-bottom: 30px;
			font-family: "Cormorant Garamond", serif;
			font-size: 48px;
			font-weight: 500;
			color: #1E2A3A;
			line-height: 1;
		}
	}

	.about {
		p {
			margin: initial;
		}

		&__top {
			margin-bottom: inherit;
		}

		&__grid {
			display: flex;
			flex-flow: row;

			@media screen and (max-width: 800px) {
				flex-flow: column;
			}

			&__card {
				flex: 1 1 auto;
			}
		}

		&__text {
			ul {
				/* list-style: none; 
				list-style: inside;*/
			}
		}
	}



    .hero + .partners {
        margin-top: 8em;
    }

    .limit-width {
	width: calc(100% - 30px);
	max-width: 1280px;
	margin: auto;
}



    .talents-hero__content {
        h2 {
            margin-bottom: 18px;

            font-size: .75rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #D97943;
        }
    }



    .partners__left {
        span {
            display: block;
            margin-bottom: 12px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #D97943;
        }
    }

    .partners__right {
        strong {
            display: block;
            margin-bottom: 5px;

            color: #fff;
        }

        p {
            color: rgba(255,255,255,.72);
        }
    }

    .talent-person-platform {
        padding: 44px 0;

        background: #F5F1EB;

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #1F2B3D;
        }

        span {
            display: block;

            margin-top: 32px;
            margin-bottom: 10px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #B45D2D;
        }

        p {
            margin-bottom: 12px;

            font-size: .94rem;
            line-height: 1.75;

            color: #394455;
        }
    }

    .talent-enduring-value {
        padding: 44px 0;

        background: #ECE8E0;

        .limit-width > h2 {
            margin-bottom: 10px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #1F2B3D;
        }

        .limit-width > h3 {
            margin-bottom: 24px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .12em;
            text-transform: uppercase;

            color: #B45D2D;
        }

        .limit-width > div {
            display: grid;
            grid-template-columns: 1fr;
        }

        article {
            min-width: 0;

            padding: 18px 0;

            h3 {
                margin-bottom: 7px;

                font-family: "Cormorant Garamond", serif;
                font-size: 1.5rem;
                font-weight: 400;

                color: #1F2B3D;
            }

            p {
                font-size: .9rem;
                line-height: 1.65;

                color: #394455;
            }
        }

        .limit-width > p {
            margin-top: 22px;

            font-family: "Cormorant Garamond", serif;
            font-size: 1.4rem;
            line-height: 1.3;

            color: #1F2B3D;
        }
    }



    .talent-ownership {
        padding: 48px 0;

        background: #1F2B3D;
        color: #fff;

        .limit-width {
            display: grid;
            grid-template-columns: 1fr;

            gap: 32px;
        }

        &__statement {
            margin-top: 28px;

            p {
                margin-bottom: 8px;

                font-size: .95rem;
                line-height: 1.75;

                color: rgba(255,255,255,.72);
            }

            strong {
                color: #fff;
            }
        }

        &__intro {

            > span {
                display: block;

                margin-bottom: 10px;

                font-size: .72rem;
                font-weight: 600;
                letter-spacing: .14em;
                text-transform: uppercase;

                color: #D97943;
            }

            h2 {
                max-width: 700px;

                margin-bottom: 20px;

                font-family: "Cormorant Garamond", serif;
                font-size: 2.35rem;
                font-weight: 400;
                line-height: 1.05;

                color: #fff;
            }

            p {
                max-width: 620px;

                margin-bottom: 12px;

                font-size: .95rem;
                line-height: 1.75;

                color: rgba(255,255,255,.7);
            }
        }

        &__options {
            display: grid;
            grid-template-columns: 1fr;

            gap: 12px;

            article {
                min-width: 0;

                padding: 20px 22px;

                background: rgba(255,255,255,.055);

                display: flex;
                align-items: center;

                min-height: 76px;

                h3 {
                    margin: 0;

                    font-family: "Cormorant Garamond", serif;
                    font-size: 1.4rem;
                    font-weight: 400;
                    line-height: 1.15;

                    color: #fff;
                }
            }
        }
    }


    @media (min-width: 768px) {

        .talent-ownership {
            padding: 56px 0;

            &__intro h2 {
                font-size: 3rem;
            }

            &__options {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }

    }


    @media (min-width: 1100px) {

        .talent-ownership {
            padding: 65px 0;

            .limit-width {
                grid-template-columns: minmax(0, .85fr) minmax(0, 1.15fr);

                gap: 75px;
                align-items: start;
            }

            &__intro {

                h2 {
                    font-size: 3.4rem;
                }

                p {
                    font-size: .97rem;
                }
            }

            &__options {
                grid-template-columns: repeat(2, minmax(0, 1fr));

                gap: 14px;
            }

            &__options article {
                padding: 22px 24px;

                min-height: 88px;
            }
        }

    }

    .talent-ecosystem {
        padding: 44px 0;

        background: #F5F1EB;

        span {
            display: block;
            margin-bottom: 10px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #B45D2D;
        }

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #1F2B3D;
        }

        p {
            font-size: .94rem;
            line-height: 1.75;

            color: #394455;
        }

        .limit-width > div {
            display: grid;
            grid-template-columns: 1fr;

            margin: 24px 0;
        }

        article {
            min-width: 0;

            padding: 16px 0;

            h3 {
                font-family: "Cormorant Garamond", serif;
                font-size: 1.4rem;
                font-weight: 400;

                color: #1F2B3D;

                overflow-wrap: break-word;
            }
        }
    }



    .talent-bridgerocks {
        padding: 44px 0;

        background: #201B1C;
        color: #fff;

        span {
            display: block;
            margin-bottom: 10px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #D97943;
        }

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #fff;
        }

        p {
            font-size: .94rem;
            line-height: 1.75;

            color: rgba(255,255,255,.7);
        }

        .limit-width > div {
            display: grid;
            grid-template-columns: 1fr;

            margin: 24px 0;
        }

        article {
            min-width: 0;

            padding: 18px 0;

            h3 {
                margin-bottom: 7px;

                font-family: "Cormorant Garamond", serif;
                font-size: 1.45rem;
                font-weight: 400;

                color: #fff;
            }

            p {
                font-size: .9rem;
                line-height: 1.65;
            }
        }
    }



    .talent-beyond-career {
        padding: 44px 0;

        background: #ECE8E0;

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #1F2B3D;
        }

        p {
            margin-bottom: 11px;

            font-size: .94rem;
            line-height: 1.75;

            color: #394455;
        }
    }



    .talent-selection {
        padding: 44px 0;

        background: #F5F1EB;

        span {
            display: block;
            margin-bottom: 10px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #B45D2D;
        }

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #1F2B3D;
        }

        p {
            font-size: .94rem;
            line-height: 1.75;

            color: #394455;
        }

        .limit-width > div {
            display: grid;
            grid-template-columns: 1fr;

            margin: 24px 0;
        }

        article {
            min-width: 0;

            padding: 18px 0;

            h3 {
                margin-bottom: 7px;

                font-family: "Cormorant Garamond", serif;
                font-size: 1.45rem;
                font-weight: 400;

                color: #1F2B3D;
            }

            p {
                font-size: .9rem;
                line-height: 1.65;
            }
        }
    }


    .talent-not-agency {
        padding: 44px 0;

        background: #1F2B3D;
        color: #fff;

        span {
            display: block;
            margin-bottom: 10px;

            font-size: .72rem;
            font-weight: 600;
            letter-spacing: .14em;
            text-transform: uppercase;

            color: #D97943;
        }

        h2 {
            margin-bottom: 18px;

            font-family: "Cormorant Garamond", serif;
            font-size: 2.3rem;
            font-weight: 400;
            line-height: 1.05;

            color: #fff;
        }

        p {
            font-size: .94rem;
            line-height: 1.75;

            color: rgba(255,255,255,.72);
        }
    }



    .talent-final-cta {
        padding: 48px 0;
        background: #F5F1EB;

        .limit-width {
            display: grid;
            grid-template-columns: 1fr;

            gap: 32px;
        }

        &__main {

            h2 {
                margin: 0;

                font-family: "Cormorant Garamond", serif;
                font-size: 2.35rem;
                font-weight: 400;
                line-height: 1.05;

                color: #1F2B3D;
            }
        }

        &__actions {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            gap: 16px;
            margin-top: 28px;
        }

        &__copy {
            padding: 26px;

            background: rgba(31, 43, 61, .05);

            p {
                margin: 0 0 14px;

                font-size: .95rem;
                line-height: 1.75;

                color: #394455;
            }

            p:last-child {
                margin-bottom: 0;
            }

            strong {
                color: #1F2B3D;
            }
        }
    }


    @media (min-width: 768px) {

        .talent-final-cta {
            padding: 56px 0;

            &__main h2 {
                font-size: 3rem;
            }

            &__actions {
                flex-direction: row;
                align-items: center;

                gap: 26px;
            }

            &__copy {
                padding: 32px;
            }
        }

    }


    @media (min-width: 1100px) {

        .talent-final-cta {
            padding: 68px 0;

            .limit-width {
                grid-template-columns: minmax(0, 1fr) minmax(380px, .8fr);

                gap: 85px;
                align-items: center;
            }

            &__main {

                h2 {
                    max-width: 760px;

                    font-size: 3.7rem;
                    line-height: 1;
                }
            }

            &__actions {
                margin-top: 38px;
            }

            &__copy {
                padding: 38px 42px;

                p {
                    font-size: 1rem;
                    line-height: 1.8;
                }
            }
        }

    }

    @media (min-width: 768px) {

        .talent-person-platform,
        .talent-enduring-value,
        .talent-ownership,
        .talent-ecosystem,
        .talent-bridgerocks,
        .talent-beyond-career,
        .talent-selection,
        .talent-not-agency,
        .talent-final-cta {
            padding: 54px 0;
        }

        .talent-person-platform h2,
        .talent-enduring-value .limit-width > h2,
        .talent-ownership h2,
        .talent-ecosystem h2,
        .talent-bridgerocks h2,
        .talent-beyond-career h2,
        .talent-selection h2,
        .talent-not-agency h2,
        .talent-final-cta h2 {
            font-size: 2.9rem;
        }

        .talent-enduring-value .limit-width > div,
        .talent-ownership .limit-width > div,
        .talent-selection .limit-width > div {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 32px;
        }

        .talent-ecosystem .limit-width > div {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            column-gap: 28px;
        }

        .talent-bridgerocks .limit-width > div {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 32px;
        }

        .talent-final-cta .limit-width > div {
            flex-direction: row;
            align-items: center;

            gap: 24px;
        }

    }


    @media (min-width: 1100px) {

        .talent-person-platform,
        .talent-enduring-value,
        .talent-ownership,
        .talent-ecosystem,
        .talent-bridgerocks,
        .talent-beyond-career,
        .talent-selection,
        .talent-not-agency,
        .talent-final-cta {
            padding: 62px 0;
        }

        .talent-person-platform h2,
        .talent-enduring-value .limit-width > h2,
        .talent-ownership h2,
        .talent-ecosystem h2,
        .talent-bridgerocks h2,
        .talent-beyond-career h2,
        .talent-selection h2,
        .talent-not-agency h2,
        .talent-final-cta h2 {
            font-size: 3.4rem;
        }

        .talent-person-platform .limit-width,
        .talent-beyond-career .limit-width,
        .talent-not-agency .limit-width {
            max-width: 1050px;
        }

        .talent-enduring-value .limit-width > div {
            grid-template-columns: repeat(5, minmax(0, 1fr));
            column-gap: 22px;
        }

        .talent-ownership .limit-width > div {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            column-gap: 24px;
        }

        .talent-ecosystem .limit-width > div {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            column-gap: 30px;
        }

        .talent-bridgerocks .limit-width > div {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            column-gap: 26px;
        }

        .talent-selection .limit-width > div {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            column-gap: 30px;
        }

        .talent-final-cta .limit-width {
            display: grid;
            grid-template-columns: 1.15fr .85fr;

            gap: 55px;
            align-items: center;
        }

        .talent-final-cta .limit-width > div {
            margin-top: 0;
        }

    }


}
</style>

